import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";

import axios from "axios";
import { formatMoneda, formatoFecha } from "../../util/varios";
import { Mensaje } from "../mensajes2";
import { Dimmer } from "../spinner";
import moment from "moment";
import { Input, Select } from "../../ui/inputs/Input";
import { DangerButton, InfoButton, SuccessButton } from "../../ui/buttons/Button";

export const ImpXml = (props) => {
  let op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  let XMLWriter = require("xml-writer");
  const espiritu = JSON.parse(localStorage.getItem("espiritu"));
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const riforg = JSON.parse(localStorage.getItem("riforg"));

  //const norden = espiritu === 0 || espiritu === 2 || espiritu === 3 || espiritu === 4 ? false : true;
  const norden = true;

  const [activate, setActivate] = useState(false);
  const [deshabilitado, setDeshabilitado] = useState(true);
  const [cmbAnios, setCmbAnios] = useState();
  const [cmbMeses, setCmbMeses] = useState();
  const [activo, setActivo] = useState(true);

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [datos] = useState();
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const txtFechaDesde = useRef();
  const cmbTipo = useRef();
  const txtFechaHasta = useRef();
  const cancelar = () => {
    blanquear();
    props.setShow(false);
  };
  const blanquear = () => {
    setActivate(false);
    setActivo(true);
    setDeshabilitado(true);
  };
  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onDatos(datos);
    props.setShow(false);
    blanquear();
  };
  const LlenarComboAnio = () => {
    var n = new Date().getFullYear();
    var a = [];
    for (var i = n; i >= 2015; i--) {
      a.push({ anio: i });
    }
    setCmbAnios(a);
    var meses = [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ];
    var m = [];
    for (var x = 0; x < 12; x++) {
      m.push({ nummes: x + 1, mes: meses[x] });
    }
    setCmbMeses(m);
  };

  const currentDate = new Date();
  const maxDate = currentDate.toISOString().split("T")[0];
  const imprimirXls = () => {
    if (txtFechaDesde.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar la Fecha de Desde",
        icono: "informacion",
      });
      txtFechaDesde.current.focus();
      return;
    } else if (txtFechaHasta.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar la Fecha de Hasta",
        icono: "informacion",
      });
      txtFechaHasta.current.focus();
      return;
    }

    var reporte = "";
    var sql = "";
    if (norden) {
      reporte = "RelacionISLRNumOrden";
    } else {
      reporte = "RelacionISLR";
    }
    var fechad = moment.utc(txtFechaDesde.current.value).format("DD/MM/YYYY");
    var fechah = moment.utc(txtFechaHasta.current.value).format("DD/MM/YYYY");
    sql = " Between" + "'" + fechad + "'" + " AND " + "'" + fechah + "'";
    var sql1 = "DESDE EL DIA " + fechad + " HASTA EL DIA " + fechah;
    let ruta =
      op.reportes +
      "/administracionTesoreria/crearxls?" +
      "reporte=" +
      reporte +
      "&FECHA=" +
      sql +
      "&FECHA_DESDE=" +
      sql1 +
      "&DESDE=" +
      "'" +
      fechad +
      "'" +
      "&HASTA=" +
      "'" +
      fechah +
      "'" +
      "&EFISCAL=" +
      idefiscal;

    axios.get(ruta, { responseType: "blob" }).then((response) => {
      let now = new Date();

      const nombre = "RelacionISLR" + formatoFecha(now, "dd/mm/yyyy") + ".xlsx";
      const file = new Blob([response.data], { type: "application/xlsx" });

      const fileURL = URL.createObjectURL(file);
      const pdfWindow = window.open();
      const link = document.createElement("a");
      link.href = fileURL;
      link.setAttribute("download", nombre);
      document.body.appendChild(link);
      link.click();
    });
  };

  const generarXml = () => {
    if (txtFechaDesde.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar la Fecha de Desde",
        icono: "informacion",
      });
      txtFechaDesde.current.focus();
      return;
    } else if (txtFechaHasta.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar la Fecha de Hasta",
        icono: "informacion",
      });
      txtFechaHasta.current.focus();
      return;
    }
    let endpoint = `${op.conexion}/api/administracion/seleccionarretencionesxml?fecini=${txtFechaDesde.current.value}&&fecfin=${txtFechaHasta.current.value}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            let xml = new XMLWriter();
            var cNumFac, cNumCon, codconcep, fecharet;
            var totalReten = 0.0,
              nFactor = 0.0,
              nRet = 0.0,
              tRet = 0.0,
              totRet = 0.0;
            xml.startDocument().startElement("RelacionRetencionesISLR");
            xml.writeAttribute(
              "RifAgente",
              riforg.trim().replaceAll("-", "").toUpperCase()
            );
            for (let i = 0; i < response.data.length; i++) {
              if (i === 0) {
                xml.writeAttribute(
                  "Periodo",
                  response.data[i].fecharet.toString().substring(0, 4) +
                    response.data[i].fecharet.toString().substring(5, 7)
                );
              }
              cNumFac = response.data[i].numfactura.trim();
              cNumCon = response.data[i].numcontrol.trim().replaceAll("-", "");
              fecharet = moment.utc(response.data[i].fecharet).format("DD/MM/YYYY");
              codconcep = response.data[i].clasifisrl.trim();
              nRet = response.data[i].mto_operacion;
              totRet = response.data[i].monto;
              totRet = Math.round(totRet * Math.pow(10, 2)) / Math.pow(10, 2);
              tRet = Math.round(nRet * Math.pow(10, 2)) / Math.pow(10, 2);
              nRet = Math.round(nRet * Math.pow(10, 2)) / Math.pow(10, 2);
              totalReten = parseFloat(totalReten) + parseFloat(totRet);
              nFactor = response.data[i].porc_unidad;
              xml.startElement("DetalleRetencion");
              xml.writeElement(
                "RifRetenido",
                response.data[i].rifcontri
                  .replaceAll("-", "")
                  .toUpperCase()
                  .trim()
              );
              xml.writeElement("NumeroFactura", cNumFac);
              xml.writeElement("NumeroControl", cNumCon);
              xml.writeElement("FechaOperacion", fecharet);
              xml.writeElement("CodigoConcepto", codconcep);
              xml.writeElement("MontoOperacion", nRet.toString());
              xml.writeElement("PorcentajeRetencion", nFactor.toString());
              xml.endElement();
            }
            let now = new Date();
            const nombre =
              "RelacionISLR" + formatoFecha(now, "dd/mm/yyyy") + ".xml";
            const file = new Blob([xml], { type: "text/xml" });
            const fileURL = URL.createObjectURL(file);
            const link = document.createElement("a");
            link.href = fileURL;
            link.setAttribute("download", nombre);
            document.body.appendChild(link);
            link.click();
            setMensaje({
              mostrar: true,
              titulo: "Error.",
              texto:
                "EL TOTAL A ENTERAR  ES: " +
                formatMoneda(
                  totalReten.toString().replace(",", "").replace(".", ","),
                  ",",
                  ".",
                  2
                ),
              icono: "error",
            });
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Error.",
              texto: "¡No hay registros que cumplan con la condición!",
              icono: "error",
            });
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };
  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setActivo(false);
        LlenarComboAnio();
      }}
    >
      <Modal.Header className="azulGradiant px-4 py-2">
        <h3 className="fs-4 text-light fw-bold m-0">Generar XML</h3>
        <button className="btn btn-sm bg-light" onClick={cancelar}>
          <i className="fa fa-times"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Dimmer active={activate} inverted></Dimmer>
        <div className="col-12 p-2 m-0 d-flex flex-wrap">
          <div className="w-100 col-12 input-group input-group-sm m-0 mb-2 p-0">
            <Select label = 'Tipo de Retención:'
                options={[
                    { value: "", label: "--Seleccione--" },
                    { value: "ISLR", label: "ISLR" },
                    { value: "IVA", label: "IVA" },
                ]}
                ref={cmbTipo}
            >
            </Select>
          </div>
          <div className="col-6 m-0 p-0">
            <Input label = 'Desde:'
              type="date"
              id="inputDireccion"
              ref={txtFechaDesde}
            />
          </div>
          <div className="col-6 m-0 p-0">
            <Input label = 'Hasta:'
              type="date"
              max={maxDate}
              id="inputDireccion"
              ref={txtFechaHasta}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-end gap-2">
        <InfoButton icon = 'fa-print'
          onClick={imprimirXls}
          disabled={activo}
          ref={btnAcepta}
        >
          Imprimir
        </InfoButton>
        <SuccessButton
          onClick={generarXml}
          disabled={activo}
          ref={btnAcepta}
        >
          Generar
        </SuccessButton>
        <DangerButton onClick={cancelar}>
           Cancelar
        </DangerButton>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
    </Modal>
  );
};
